import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEthereumIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_12327_2268)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12.333 3.88421V22.1839",
				stroke: "white",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M20.0224 12.9795L12.3331 16.6291L4.66113 13.0132",
				stroke: "white",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.5467 3.37992C11.9471 2.87035 12.7189 2.87035 13.1193 3.37992L20.0976 12.2613C20.3825 12.6239 20.3825 13.1344 20.0976 13.497L13.1193 22.3784C12.7189 22.888 11.9471 22.888 11.5467 22.3784L4.56844 13.497C4.28353 13.1344 4.28353 12.6239 4.56844 12.2613L11.5467 3.37992Z",
				stroke: "white",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_12327_2268",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white",
			transform: "translate(0.333008 0.87915)"
		})
	}) })]
});
export default SvgEthereumIcon;
